import OperatorsPharmacistPage from './OperatorsPharmacistPage';
import operatorsPageReducer from './reducer';

export { operatorsPageReducer };

export default OperatorsPharmacistPage;
